import React, { useEffect, useState } from 'react';
import { adminAPI } from '../utils/api';

function AdminPaymentSettingsManager() {
  const [settings, setSettings] = useState(null);
  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => { adminAPI.getPaymentSettings().then(r => setSettings(r.data)).catch(e => setMessage(e.response?.data?.message || 'Unable to load payment settings.')); }, []);
  if (!settings) return <div>{message || 'Loading payment settings...'}</div>;

  const toggle = (group, key) => setSettings(current => ({ ...current, [group]: { ...current[group], [key]: !current[group][key] } }));
  const save = async () => {
    setSaving(true); setMessage('');
    try { const response = await adminAPI.updatePaymentSettings(settings); setSettings(response.data); setMessage('Payment settings saved.'); }
    catch (error) { setMessage(error.response?.data?.message || 'Unable to save payment settings.'); }
    setSaving(false);
  };

  return <div style={styles.card}>
    <h3>Marketplace Payment Controls</h3>
    <p>NOWPayments uses each plugin author's own API key and wallet settings. The repository does not receive or hold the cryptocurrency.</p>
    <label style={{...styles.field, maxWidth: 620}}>NOWPayments referral link
      <input
        type="url"
        value={settings.nowPaymentsReferralUrl || ''}
        onChange={e => setSettings({...settings, nowPaymentsReferralUrl: e.target.value})}
        placeholder="https://nowpayments.io/..."
        maxLength={2000}
        style={styles.input}
      />
      <span style={styles.help}>This link is shown to users who have not connected a NOWPayments account.</span>
    </label>
    <h4>Payment providers</h4>
    {['nowpayments', 'paypal'].map(provider => <label key={provider} style={styles.row}>
      <input type="checkbox" checked={Boolean(settings.providers?.[provider])} onChange={() => toggle('providers', provider)} />
      {provider === 'nowpayments' ? 'NOWPayments' : 'PayPal'}
    </label>)}
    <label style={styles.field}>Default provider
      <select value={settings.defaultProvider} onChange={e => setSettings({...settings, defaultProvider: e.target.value})} style={styles.select}>
        {Object.entries(settings.providers || {}).filter(([, enabled]) => enabled).map(([id]) => <option key={id} value={id}>{id === 'nowpayments' ? 'NOWPayments' : 'PayPal'}</option>)}
      </select>
    </label>
    <h4>Accepted cryptocurrencies</h4>
    {['btc', 'eth'].map(currency => <label key={currency} style={styles.row}>
      <input type="checkbox" checked={Boolean(settings.payCurrencies?.[currency])} onChange={() => toggle('payCurrencies', currency)} /> {currency.toUpperCase()}
    </label>)}
    <label style={styles.field}>Default cryptocurrency
      <select value={settings.defaultPayCurrency} onChange={e => setSettings({...settings, defaultPayCurrency: e.target.value})} style={styles.select}>
        {Object.entries(settings.payCurrencies || {}).filter(([, enabled]) => enabled).map(([id]) => <option key={id} value={id}>{id.toUpperCase()}</option>)}
      </select>
    </label>
    <button onClick={save} disabled={saving} style={styles.button}>{saving ? 'Saving...' : 'Save Payment Settings'}</button>
    {message && <div style={styles.message}>{message}</div>}
  </div>;
}

const styles = {
  card: { maxWidth: 720, border: '1px solid #dbe3ef', borderRadius: 10, padding: 24, lineHeight: 1.5 },
  row: { display: 'flex', gap: 10, alignItems: 'center', margin: '10px 0' },
  field: { display: 'grid', gap: 6, margin: '18px 0', maxWidth: 360, fontWeight: 600 },
  select: { padding: 10, border: '1px solid #cbd5e1', borderRadius: 6, background: 'white' },
  input: { padding: 10, border: '1px solid #cbd5e1', borderRadius: 6, background: 'white' },
  help: { fontSize: 13, color: '#64748b', fontWeight: 400 },
  button: { padding: '11px 18px', border: 0, borderRadius: 6, background: '#667eea', color: 'white', cursor: 'pointer' },
  message: { marginTop: 14, padding: 10, background: '#eef6ff', borderRadius: 6 }
};

export default AdminPaymentSettingsManager;
